// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WidgetWrapper_wrapper__3Fghi","clickable":"WidgetWrapper_clickable__2nWhy"};